module.exports = __webpack_public_path__ + "static/media/combo_ride_6.e87bc5e2.png";